import { ProtectedRoute } from "@app/protected-route";
import Config from "@pages/stress-test/config/config";
import { createFileRoute } from "@tanstack/react-router";

interface ConfigSearch {
	tab?: string;
}

export const Route = createFileRoute("/_layout/stress-test/config")({
	component: RouteComponent,
	validateSearch: (search: Record<string, unknown>): ConfigSearch => ({
		tab: (search.tab as string) || "mapping",
	}),
});

function RouteComponent() {
	return (
		<ProtectedRoute requiredPermissions={["ifrs_config"]}>
			<Config />
		</ProtectedRoute>
	);
}
